var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaveFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 47.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00b4d8;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "waveFront") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.5,431.27l6.5.33c6.5.36,19.5,1,32.5,2s26,2.39,39,3a230,230,0,0,0,39.2-1.18c13.1-1.62,26.5-4.7,39.6-4.49s26.2,3.68,39.2,3.36,26-4.54,39-6.16,26-.65,39,1.3,26,4.94,39,5.95,26,0,39-1,26-2.31,39-2.19,26,1.62,39.2,1.3,26.5-2.51,39.6-2.92,26.2,1,39.2,1.79a291.71,291.71,0,0,0,39,.12c13-.93,26-3.12,39-2.72s26,3.41,39,3.32,26-3.16,39-4.17,26,0,39,.24,26-.44,39.2-.6,26.5.28,39.6.69,26.2.81,39.2,1.41,26,1.42,39,1.34,26-1,32.5-1.46l6.5-.48v20.66H.5Z",
    transform: "translate(-0.5 -400)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveFront);
export default __webpack_public_path__ + "static/media/waveFront.bd5d48c4b57b85a1bd287241a719e7fc.svg";
export { ForwardRef as ReactComponent };